import React, { useEffect, useRef, useState } from "react";
import Sidebar from "./Sidebar";
import MainBody from "./MainBody";
import { GET_BOOKING_GROUPS, SET_THREAD_COUNTER } from "../../../../redux/constants";
import { useDispatch, useSelector } from "react-redux";
import { socket } from "../../../../service/socket";
import { useLocation, useNavigate } from "react-router-dom";

const ChatIndex = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const activeGroupRef = useRef(null);
  const { subGroup } = useSelector((state) => state.todoPerformance);
  const {email} = useSelector(state => state.auth);
  const { messagesList } = useSelector((state) => state.chat);

  const [activeGroup, setActiveGroup] = useState({});
  const [msgList, setMsgList] = useState([]);
  const [page, setPage] = useState(1);
  const hasMoreRef = useRef(true);

  useEffect(() => {
    return () => {
      setActiveGroup({});
    };
  }, []);

  useEffect(() => {
    if(location?.state?.sub_group_id){
      const selected = subGroup.find((item) => item.sub_group_id === location.state.sub_group_id);
      if(selected){
        setActiveGroup(selected)
        navigate(location.pathname, { replace: true });
      }
    }
  }, [subGroup]);

  useEffect(() => {
    setMsgList(messagesList);
    return () => { 
      setMsgList([]);
    };
  }, [messagesList]);

  // // Group Message Received Lisinter
  useEffect(() => {
    socket.on("receive_group_message", async (data) => {
      setMsgList((prev) => {
        const oldMessages = prev.filter(
          (item) => item.chat_id !== data.success.chat_id
        );
        return [data.success, ...oldMessages];
      });

      const payload = {
        company_id: activeGroupRef.current?.company_id,
        main_group_id: activeGroupRef.current?.main_group_id,
        sub_group_id: activeGroupRef.current?.sub_group_id,
        email: email
      }
      socket.emit("mark_read_group_message", payload);

      let newMessageGroup = subGroup.find(
        (item) => item.sub_group_id === data.success.sub_group_id
      );
      if (newMessageGroup) {
        newMessageGroup["message"] = data.success.message;
        newMessageGroup["createdAt"] = data.success.createdAt;
        newMessageGroup["is_read"] = activeGroupRef.current?.sub_group_id === data.success.sub_group_id ? "" : data.success.is_read;

        const oldMessageGroup = subGroup.filter(
          (item) => item.sub_group_id !== data.success.sub_group_id
        );

        if(data.success.is_read?.includes(email)){
          const counter = [newMessageGroup, ...oldMessageGroup].filter(item => item.is_read?.includes(email)) || [];
          dispatch({type: SET_THREAD_COUNTER, payload: counter.length });
        }

        dispatch({
          type: GET_BOOKING_GROUPS,
          payload: [newMessageGroup, ...oldMessageGroup],
        });
      }
    });
  }, []);

  return (
    <div className="flex flex-row w-full h-full">
      <Sidebar activeGroup={activeGroup} setActiveGroup={setActiveGroup} activeGroupRef={activeGroupRef} setPage={setPage} hasMoreRef={hasMoreRef} />
      {Object.keys(activeGroup).length !== 0 && (
        <MainBody activeGroup={activeGroup} msgList={msgList} page={page} setPage={setPage} hasMoreRef={hasMoreRef} />
      )}
    </div>
  );
};

export default ChatIndex;
